import { render, staticRenderFns } from "./OptionEditor.vue?vue&type=template&id=a2120810&scoped=true&"
import script from "./OptionEditor.vue?vue&type=script&lang=ts&"
export * from "./OptionEditor.vue?vue&type=script&lang=ts&"
import style0 from "./OptionEditor.vue?vue&type=style&index=0&id=a2120810&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2120810",
  null
  
)

export default component.exports